module.exports = __webpack_public_path__ + "static/media/team19.d2c9086a.png";